import { useState } from "react";
import { FaUsers } from "react-icons/fa";

const ReusableCard = ({ image, name, city, date }) => {
  const [errored, setErrored] = useState(false);

  return (
    <div
      className="
        group
        rounded-2xl border border-neutral-200
        bg-white
        shadow-sm
        hover:shadow-lg
        transition
        duration-200
        overflow-hidden
      "
    >
      {/* Header visual */}
      <div className="h-24 bg-gradient-to-r from-green-500 via-teal-500 to-blue-600" />

      {/* Imagen / Icon */}
      <div className="flex justify-center -mt-12">
        {image && !errored ? (
          <img
            src={image}
            alt={name}
            onError={() => setErrored(true)}
            className="
              w-24 h-24 rounded-full object-cover
              border-4 border-white shadow-md
            "
          />
        ) : (
          <div
            className="
              w-24 h-24 rounded-full bg-neutral-200
              border-4 border-white shadow-md
              flex items-center justify-center
            "
          >
            <FaUsers className="text-neutral-500 text-3xl" />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="px-4 py-3 text-center">
        <div className="text-lg font-semibold text-neutral-900">{name}</div>
        <div className="text-sm text-neutral-600">{city}</div>

        {date && (
          <span
            className="
              inline-block mt-2 px-2 py-[2px]
              text-xs bg-neutral-100 text-neutral-600
              rounded-md
            "
          >
            {new Date(date).toLocaleDateString()}
          </span>
        )}
      </div>
    </div>
  );
};

export default ReusableCard;
